import { Button, styled } from "@mui/material";

export const SubmitButton = styled(Button)({
  borderRadius: 10,
  width: "100%",
  backgroundColor: "#f30a0aff",
  color: "#f2f2f6ff",
  fontSize: 18,
  padding: "10px 10px",
  "&:disabled": {
    backgroundColor: "#E0E0E0",
  },
  "&:hover": {
    backgroundColor: "#f13b3bff",
  },
  "& svg": {
    marginRight: 10,
    width: 20,
    height: 20
  }
});
